module.exports = "<div *ngIf=\"mostrarErro\" >\n  <span class=\"glyphicon glyphicon-remove form-control-feedback\"></span>\n  <span class=\"sr-only\">(error)</span>\n  <div class=\"alert alert-danger errorDiv\" role=\"alert\">\n    {{ msgErro }}\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/hc/angular/adminHC/src/app/shared/campo-control-erro/campo-control-erro.component.html
// module id = ../../../../../src/app/shared/campo-control-erro/campo-control-erro.component.html
// module chunks = main